export class DarkThemeUtil {
    static GetSetDarkTheme() {
      let isDarkTheme = window.localStorage.getItem('isDarkTheme'); //return null if it dont exist
      if(isDarkTheme !== null) {
        isDarkTheme = (isDarkTheme == 'true') ? true : false;
        document.documentElement.setAttribute('data-theme', isDarkTheme ? 'dark' : 'light');
      } else {
        isDarkTheme = window.matchMedia('(prefers-color-scheme: dark)').matches;
        document.documentElement.setAttribute('data-theme', isDarkTheme ? 'dark' : 'light');
      }
      return isDarkTheme;
    }
    static GetThemeMode() {
      let themeMode = window.localStorage.getItem('isDarkTheme'); //return null if it dont exist
      if(themeMode !== null) {
        themeMode = themeMode === 'true' ? "dark" : "light";
      } else {
        themeMode = "system";
      }
      return themeMode;
    }
}
